module.exports = __webpack_public_path__ + "media/images/tmp/shoes-0a2c660dcd90f53f65173c25d2df2b87.png";